module.exports = __webpack_public_path__ + "static/media/venue.28e59c1a.svg";